import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import { IndexMessageVo, MessageVo, QueryNotificationList, UnReadMessageVo, IndexChatVo } from './types';
/**
 * chat 获取认证token
 */
export const chatAuthentication = (): AxiosPromise<string> => {
  return request({
    url: '/member/chat/authentication',
    method: 'get'
  });
};

/**
 * Notification 站内信 已读消息
 */

export const notificationRead = (data?: { messageId?: string }): AxiosPromise<boolean> => {
  return request({
    url: '/member/message/read',
    method: 'post',
    data
  });
};

/**
 * Notification 首页未读消息列表、未读消息数量
 */

export const notificationIndexList = (): AxiosPromise<IndexMessageVo> => {
  return request({
    url: '/member/message/indexList',
    method: 'get'
  });
};

/**
 * Notification  member页 通知列表数据
 */

export const notificationList = (params: QueryNotificationList): AxiosPromise<MessageVo> => {
  return request({
    url: '/member/message/list',
    method: 'get',
    params
  });
};

/**
 * Notification  member页 通知列表未读消息个数
 */
export const notificationUnReadMessageNum = (): AxiosPromise<UnReadMessageVo> => {
  return request({
    url: '/member/message/unReadMessageNum',
    method: 'get'
  });
};

/**
 * Chat 首页chat消息记录
 */

export const chatIndexChatList = (params: { pageSize: number | string; pageNum: number | string }): AxiosPromise<IndexChatVo> => {
  return request({
    url: '/member/chat/indexChatList',
    method: 'get',
    params
  });
};
/**
 * Chat 已读会话
 */

export const chatRead = (data?: { conversationIds?: string }): AxiosPromise<boolean> => {
  return request({
    url: '/member/chat/read',
    method: 'post',
    data
  });
};
